type OfficeInfoProps = {
    /** Inside contact card below AutoForm — divider only, no separate box */
    embedded?: boolean;
};

export function OfficeInfo({ embedded = false }: OfficeInfoProps) {
    const content = (
        <>
            <h2 className="text-xs font-semibold uppercase tracking-wide text-[#848a85] mb-2">
                Mailing address
            </h2>
            <address className="not-italic text-sm leading-relaxed text-[#555656]">
                <span className="font-medium text-[#1c5375]">Learn Your Way Ltd</span>
                <br />
                Bartle House,
                <br />
                Oxford Court,
                <br />
                Manchester M2 3WQ
            </address>
        </>
    );

    if (embedded) {
        return (
            <div
                className="border-t border-slate-200 pt-6 mt-6 w-full text-[#656565]"
                aria-label="Mailing address"
            >
                {content}
            </div>
        );
    }

    return (
        <aside
            className="mt-2 rounded-lg border border-slate-200 bg-slate-50/70 px-5 py-4 text-[#656565] max-w-xl"
            aria-label="Mailing address"
        >
            {content}
        </aside>
    );
}
